<script setup lang="ts">
import { encodeImageSlug, imageUrl, isImageMatch } from '../utils/url.ts'

defineProps({
  thumbnail: {
    type: Object,
    default: null
  }
})

const route = useRoute()
const pathSegments = computed(() => {
  const pathParam = route.params.path
  return (Array.isArray(pathParam) ? pathParam : pathParam ? [pathParam] : [])
    .flatMap(segment => segment.split('/'))
    .map(segment => segment.trim())
    .filter(Boolean)
})

const galleriesIndex = computed(() => pathSegments.value.indexOf('galleries'))
const detailIndex = computed(() => pathSegments.value.indexOf('detail'))

const galleryName = computed(() => {
  const index = galleriesIndex.value
  return index >= 0 ? (pathSegments.value[index + 1] || '') : ''
})

const detailSlug = computed(() => {
  const index = detailIndex.value
  return index >= 0 ? (pathSegments.value[index + 1] || '') : ''
})

const galleryBasePath = computed(() => {
  const index = galleriesIndex.value
  if (index >= 0) {
    const topicSegments = pathSegments.value.slice(0, index)
    return `/topics/${topicSegments.join('/')}/galleries/${galleryName.value}`
  }

  return ''
})

function isCurrentImage(pathname: string) {
  if (!detailSlug.value) return false

  return isImageMatch(pathname, detailSlug.value)
}
</script>

<template>
  <li
    v-if="detailSlug && !thumbnail.isUploading"
    class="text-black inline-block relative"
    :class="{ 'z-50': isCurrentImage(thumbnail.pathname) }"
  >
    <NuxtLink :to="`${galleryBasePath}/detail/${encodeImageSlug(thumbnail.pathname)}`">
      <img
        v-if="thumbnail"
        width="83"
        height="51"
        :src="imageUrl(thumbnail.pathname, 'thumb')"
        :alt="thumbnail.key"
        class="object-cover rounded-md transition-all duration-500 hover:brightness-100 w-[83px] h-[51px]"
        :class="isCurrentImage(thumbnail.pathname) ? 'active brightness-100' : 'opacity-75 brightness-50'"
      >
    </NuxtLink>
  </li>
</template>
